/** @module SiteAdmin/Locale/LocaleCodeRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/String",
	"csi/locale"
], function(declare,StringRen,locale) {

	return declare(StringRen, {
		/**
		 * @override
		 * disable filtering
		 */
		getQuerySpec: function(ctx, h, spec) {
			return null;
		},

		/**
		 * @override
		 * return original name
		 */
		toValue: function(ctx, h) {
			return ctx.getNode().$Name;
		}
	});
});